import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Loader from "../Loader/Loader";

const AccountTypeLayer = () => {
  const { AsyncGetApiCall, AsyncPostApiCall, AsyncPatchApiCall, AsyncDeleteApiCall } = useApi();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ name: "", isActive: true });

  const fetchList = async () => {
    setLoading(true);
    const res = await AsyncGetApiCall("/trading-settings/account-type");
    if (res?.success) setList(res.data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) return toast.error("Name is required");

    const res = editId
      ? await AsyncPatchApiCall(`/trading-settings/account-type/update/${editId}`, formData)
      : await AsyncPostApiCall("/trading-settings/account-type/create", formData);

    if (res) {
      toast.success(editId ? "Updated successfully" : "Created successfully");
      setShowModal(false);
      setEditId(null);
      setFormData({ name: "", isActive: true });
      fetchList();
    }
  };

  const handleEdit = (item) => {
    setEditId(item._id);
    setFormData({ name: item.name, isActive: item.isActive });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this account type?")) return;
    const res = await AsyncDeleteApiCall(`/trading-settings/account-type/delete/${id}`);
    if (res) {
      toast.success("Deleted successfully");
      fetchList();
    }
  };

  if (loading && list.length === 0) return <Loader />;

  return (
    <div className="card h-100 p-0 radius-12">
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex justify-content-between align-items-center">
        <h6 className="text-lg fw-semibold mb-0">Manage Account Types</h6>
        <button
          onClick={() => {
            setEditId(null);
            setFormData({ name: "", isActive: true });
            setShowModal(true);
          }}
          className="btn btn-primary-600 btn-sm d-flex align-items-center gap-2"
        >
          <Icon icon="lucide:plus" /> Add New
        </button>
      </div>
      <div className="card-body p-24">
        <div className="table-responsive">
          <table className="table basic-table mb-0">
            <thead>
              <tr>
                <th className="fw-semibold text-primary-light">Name</th>
                <th className="fw-semibold text-primary-light">Status</th>
                <th className="fw-semibold text-primary-light">Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item) => (
                <tr key={item._id}>
                  <td>
                    <h6 className="text-md mb-0 fw-medium">{item.name}</h6>
                  </td>
                  <td>
                    <span
                      className={`${item.isActive
                        ? "bg-success-focus text-success-600"
                        : "bg-danger-focus text-danger-600"
                        } px-24 py-8 radius-8 fw-medium text-sm d-inline-flex align-items-center`}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        onClick={() => handleEdit(item)}
                        className="w-40-px h-40-px bg-success-focus text-success-600 rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                      >
                        <Icon icon="lucide:edit" className="text-lg" />
                      </button>
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="w-40-px h-40-px bg-danger-focus text-danger-600 rounded-circle d-inline-flex align-items-center justify-content-center border-0"
                      >
                        <Icon icon="lucide:trash-2" className="text-lg" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {list.length === 0 && (
                <tr>
                  <td colSpan="3" className="text-center py-24 text-secondary-light">
                    No account types found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editId ? "Edit Account Type" : "Add Account Type"}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Account Type Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      placeholder="ENTER ACCOUNT TYPE"
                      required
                    />
                  </div>
                  <div className="form-check form-switch mt-16">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={formData.isActive}
                      onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                      id="accountTypeStatus"
                    />
                    <label className="form-check-label" htmlFor="accountTypeStatus">
                      Active Status
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary-600">Save Changes</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountTypeLayer;
